import { render } from "./AccountInfo.vue?vue&type=template&id=cffa6362"
import script from "./AccountInfo.vue?vue&type=script&lang=js"
export * from "./AccountInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/wilsus-portal/wilsus-portal/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__